var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00003 0.5C12.1556 0.5 15.5 3.89263 15.5 7.65039C15.4999 11.4844 13.0505 15.6555 9.26956 17.2461H9.26859C8.87327 17.4127 8.4401 17.5 8.00003 17.5C7.55996 17.5 7.12679 17.4127 6.73148 17.2461H6.7305C2.94958 15.6555 0.500125 11.4844 0.500031 7.65039C0.500031 3.89263 3.84449 0.5 8.00003 0.5ZM8.00003 4.0166C7.09261 4.0166 6.21269 4.34023 5.55667 4.93066C4.899 5.52265 4.51859 6.33788 4.51859 7.2002C4.5186 8.06251 4.89898 8.87775 5.55667 9.46973C6.21269 10.0602 7.09261 10.3838 8.00003 10.3838C8.90745 10.3838 9.78737 10.0602 10.4434 9.46973C11.1011 8.87775 11.4815 8.06251 11.4815 7.2002C11.4815 6.33788 11.1011 5.52265 10.4434 4.93066C9.78737 4.34023 8.90745 4.0166 8.00003 4.0166Z",
    stroke: "#413F3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationicon);
export default __webpack_public_path__ + "static/media/locationicon.78925a12ccb898f5ee630361d909fca1.svg";
export { ForwardRef as ReactComponent };